import clsx from 'clsx';
import { forwardRef } from '@wordpress/element';
import deprecated from '@wordpress/deprecated';
import { jsx as _jsx } from "react/jsx-runtime";
function UnforwardedButtonGroup(props, ref) {
  const {
    className,
    __shouldNotWarnDeprecated,
    ...restProps
  } = props;
  const classes = clsx('components-button-group', className);
  if (!__shouldNotWarnDeprecated) {
    deprecated('wp.components.ButtonGroup', {
      since: '6.8',
      alternative: 'wp.components.__experimentalToggleGroupControl'
    });
  }
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    role: "group",
    className: classes,
    ...restProps
  });
}

/**
 * ButtonGroup can be used to group any related buttons together. To emphasize
 * related buttons, a group should share a common container.
 *
 * @deprecated Use `ToggleGroupControl` instead.
 *
 * ```jsx
 * import { Button, ButtonGroup } from '@wordpress/components';
 *
 * const MyButtonGroup = () => (
 *   <ButtonGroup>
 *     <Button variant="primary">Button 1</Button>
 *     <Button variant="primary">Button 2</Button>
 *   </ButtonGroup>
 * );
 * ```
 */
export const ButtonGroup = forwardRef(UnforwardedButtonGroup);
ButtonGroup.displayName = 'ButtonGroup';
export default ButtonGroup;